const APPLE_SDK_URL = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'

let sdkPromise = null

function loadAppleSdk () {
  if (window.AppleID) {
    return Promise.resolve()
  }

  if (sdkPromise) {
    return sdkPromise
  }

  sdkPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = APPLE_SDK_URL
    script.async = true
    script.onload = () => {
      if (window.AppleID) {
        resolve()
      } else {
        sdkPromise = null
        reject(new Error('Apple SDK loaded but AppleID is unavailable'))
      }
    }
    script.onerror = () => {
      sdkPromise = null
      reject(new Error('Failed to load Apple Sign In SDK'))
    }
    document.head.appendChild(script)
  })

  return sdkPromise
}

export function canShowAppleLogin () {
  return true
}

export async function signInWithApple () {
  await loadAppleSdk()

  window.AppleID.auth.init({
    clientId: process.env.VUE_APP_APPLE_SERVICE_ID,
    scope: 'name email',
    redirectURI: process.env.VUE_APP_APPLE_REDIRECT_URL,
    usePopup: true
  })

  return window.AppleID.auth.signIn()
}

export function isAppleCancellation (reason) {
  const code = reason && reason.error
  if (code === 'popup_closed_by_user' ||
    code === 'user_cancelled_authorize' ||
    code === 'user_trigger_new_signin_flow') {
    return true
  }

  const message = (reason && (reason.message || reason.code)) || ''
  return typeof message === 'string' &&
    (message.indexOf('1001') !== -1 || message.toLowerCase().indexOf('cancel') !== -1)
}
